import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
	modalContainer: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: '80%',
		height: '80%',
		backgroundColor: 'white',
		flex: 1,
		overflow: 'auto',
		border: '0.1rem solid rgba(0, 0, 0, 0.38)',
		borderRadius: '0.4rem',
		padding: '2rem'
	},
	title: {
		textTransform: 'capitalize',
		color: 'teal',
		fontWeight: 'bold'
	},
	updateType: {
		position: 'sticky',
		top: '-2rem',
		padding: '1rem',
		backgroundColor: 'white',
		width: '100%',
		zIndex: 1000,
		display: 'inline-block',
		color: '#fc4b58',
		fontWeight: 'bold'
	},
	boxContainer: {
		flex: 1,
		overflow: 'auto',
		border: '0.1rem solid rgba(0, 0, 0, 0.38)',
		borderRadius: '0.4rem',
		padding: '1rem',
		maxHeight: '55rem'
	},
	content: {
		padding: '1rem'
	}
});

export default useStyles;
